import { h } from "preact";

import Button from "../Button.jsx";
import Icon from "../Icon.jsx";
import List from "../List.jsx";
import ListItem from "../ListItem.jsx";

import i18n from "../../i18n.js";

export default function SuccessState() {
  return (
    <section class="pt-64">
      <Icon class="mb-48" big>
        projects_requested
      </Icon>

      <h1 class="t-h6 t-h8--margin">
        {i18n.t("component.projects_add.success_state.title")}
      </h1>
      <p class="t-body3 mb-48 color-shades-grey">
        {i18n.t("component.projects_add.success_state.description")}
      </p>

      <List class="mb-64">
        <ListItem number={1}>
          {i18n.t("component.projects_add.success_state.bullet1")}
        </ListItem>
        <ListItem number={2}>
          {i18n.t("component.projects_add.success_state.bullet2")}
        </ListItem>
        <ListItem number={3}>
          {i18n.t("component.projects_add.success_state.bullet3")}
        </ListItem>
      </List>

      <Button secondary to="/projects">
        {i18n.t("component.projects_add.success_state.action")}
      </Button>
    </section>
  );
}
